import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { arrayFindNext } from '@/core/utils'
import { simakatraConfig } from '@/core/config'
import type { MainContent } from '../types'
import { MAIN_CONTENTS } from '../constants'

export const useCommonStore = defineStore('simakatra.common', () => {
  const mainContent = ref<MainContent>(simakatraConfig.main as MainContent)

  function $reset() {
    mainContent.value = arrayFindNext(MAIN_CONTENTS, mainContent.value)
  }

  return { mainContent, $reset }
})
